export default function getResource(label, vars = []) {
    const resources = {
        optinCreateHeading: 'Laissez tomber votre mot de passe lors de votre prochaine visite et connectez-vous de manière plus rapide et sécuritaire',
        subheading: 'Use the same face or fingerprint you use to unlock your device. We never receive your biometric data like fingerprints or face scans.',
        warningNotification: 'Non recommandé pour les appareils partagés.',
        termsAndConditions: 'En cliquant sur « Continuer », vous (1) acceptez la version actuelle de nos ',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        termsAndConditionsRest: ' et (2) confirmez avoir lu notre ',
        privacyPolicy: 'politique de confidentialité',
        whatIsPasskey: 'Qu’est-ce qu’une clé d’accès?',
        setupButton: 'Continuer',
        maybeLaterButton: 'Peut-être plus tard',
        laterButton: 'Plus tard',
        passkeyErrorTitle: 'Error',
        passkeyErrorMessage: 'Failed to create passkey. Please try again.',
        passkeyErrorButton: 'OK',
        createNewPasskey: 'Create New Passkey',
        cancel: 'Cancel',
        passkeyCreated: 'Passkey created!',
        optinCreateAccountHeading: 'Create a new passkey'
    };

    return resources[label];
}
